import React, { useEffect, useMemo, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { extractTableHeaders } from 'utils/hooks/reportTableUtils';
import { columnsB0701 } from 'constants/reportColumns';
import { BProps, DataTypeB0701 } from 'store/ducks/Reportings/types';

const B0701: React.FC<BProps> = ({ entityName }) => {
  const { date, is_displayed, headers } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeB0701[]>([]);
  const memoizedColumns = useMemo(() => columnsB0701, [columnsB0701]);
  const dispatch = useDispatch();
  const fetchData = async () => {
    dispatch(set_isDisplayed(false));
    const entityIds: string[] = entityName
      ? entityName.split(',').map((id) => id.trim())
      : [];

    const params = {
      entityId: entityIds,
      date,
    };

    try {
      const fetchedData = await reportingOp.fetchRT0701(params);

      if (fetchedData && fetchedData.entities) {
        const date = fetchedData.date;
        const allEntities = Object.values(fetchedData.entities).flat();

        const formattedData = allEntities.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: dataItem.entity_name,
            contractual_arrangement_reference_number:
              dataItem['Arrangement reference number'],
            identification_code_of_ICT_provider:
              dataItem['ICT service provider identification code'],
            type_of_code_of_ICT_provider:
              dataItem['Type of ICT service provider code'],
            type_of_ICT_services: dataItem['Type of ICT services'],
            sustainability_of_ICT_provider:
              dataItem['Substitutability of ICT provider'],
            reason_of_substitutable:
              dataItem['Reason for non-substitutability'],
            date_of_last_audit: dataItem['Date of last audit'],
            existance_of_exit_plan: dataItem['Exit plan exists'],
            possibility_of_reintegration: dataItem['Reintegration possible'],
            impact_of_discontinuing_ICT_services:
              dataItem['Impact of discontinuing ICT services'],
            alternative_ICT_identified:
              dataItem['Alternative providers identified'],
            identification_of_alternative_ICT_TPP:
              dataItem['Alternative ICT TPP identification'],
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_displayed, entityName]);

  useEffect(() => {
    extractTableHeaders(memoizedColumns, dispatch);
  }, []);

  return (
    <>
      <Table
        columns={columnsB0701}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default B0701;
